import { Body1, Header1, SubBody1 } from '@flatsy/core/MaterialUi/Typo'
import React from 'react'
import FormatPrice from '@flatsy/core/Format/Price'
import { useParams } from 'react-router'
import { useAsset } from 'src/hooks/Asset'
import { LogoAgency } from 'src/utils/LogoAgency'
import i18n from '@flatsy/utils/translations'
import PlaceOutlinedIcon from '@material-ui/icons/PlaceOutlined'
import { priceValue } from '@flatsy/utils/Functions/format/Conversions'
import theme from '@flatsy/core/MuiTheme/theme'
import { useStyles } from './Styles'

const Cancelled: React.FC = (): React.ReactElement => {
  const classes = useStyles()
  const { assetId } = useParams<{ assetId: string }>()
  const { asset } = useAsset(assetId)

  const style = {
    information: asset?.thumbnail ? classes.informationThumbnail : classes.information,
    text: asset?.thumbnail ? classes.textThumbnail : classes.text,
    price: asset?.thumbnail ? classes.priceThumbnail : classes.price,
    localisation: asset?.thumbnail ? classes.localisationThumbnail : classes.localisation,
    line: asset?.thumbnail ? classes.lineThumbnail : classes.line,
  }

  return (
    <div className={classes.container}>
      {LogoAgency(classes, asset?.logo_url)}
      <div className={classes.card}>
        <Header1 lowerCase align="center">
          {i18n.t('your_application_has_been_closed')}
        </Header1>
        <div className={style.information}>
          {asset?.thumbnail && (
            <img src={asset?.thumbnail} alt="asset place" className={classes.img} />
          )}
          <div className={style.text}>
            <Header1 lowerCase fontColor={theme.palette.primary.dark} className={style.price}>
              {asset && <FormatPrice price={priceValue(asset)} />}{' '}
              {!asset?.is_sale && i18n.t('per_month').toLowerCase()}
            </Header1>
            <SubBody1 align="center">
              {!asset?.is_sale && i18n.t('utilities_included').toLowerCase()}
            </SubBody1>
            <div className={style.line} />
            <div className={style.localisation}>
              <PlaceOutlinedIcon className={classes.icon} />
              <Body1 className={classes.address} fontColor={theme.palette.primary.dark}>
                {asset?.address_description}
              </Body1>
            </div>
          </div>
        </div>
      </div>
    </div>
  )
}

export default Cancelled
